<template>
  <section class="projects" id="projects">
    <div class="header">
      <div>
        <p class="eyebrow">Selected work</p>
        <h2>Projects that ship</h2>
        <p class="lede">A few builds that reflect how I approach product craft: shipping fast, keeping quality high, and keeping the experience cohesive.</p>
      </div>
      <a class="more" href="mailto:prietotomas01@gmail.com">Open to collaborations →</a>
    </div>

    <div class="grid">
      <article class="project-card" v-for="project in projectData.ProjectsArray" :key="project.id">
        <div class="card-top">
          <img :src="resolveImage(project.image)" :alt="project.title" />
        </div>
        <div class="card-body">
          <div class="title-row">
            <div>
              <p class="eyebrow">Mobile · Product delivery</p>
              <h3>{{ project.title }}</h3>
            </div>
            <a class="pill-link" :href="project.link" target="_blank" rel="noopener">View</a>
          </div>
          <p class="summary">{{ project.about }}</p>
          <div class="pill-row">
            <span v-for="tech in project.tech" :key="tech" class="pill">{{ tech }}</span>
          </div>
        </div>
      </article>
    </div>
  </section>
</template>
<script>
import jsonData from '/projects.json'

export default {
  name: 'ProjectsCard',
  data() {
    return {
      projectData: jsonData
    }
  },
  methods: {
    resolveImage(src) {
      if (!src) return ''
      if (/^https?:/i.test(src)) return src
      try {
        return require(`@/assets/${src}`)
      } catch (e) {
        return src
      }
    }
  }
}
</script>

<style scoped>
.projects {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 24px;
  padding: 24px;
  backdrop-filter: blur(12px);
  box-shadow: 0 20px 80px rgba(0, 0, 0, 0.25);
}

.header {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 18px;
}

.header h2 {
  margin: 4px 0;
  font-size: 26px;
}

.lede {
  margin: 0;
  color: var(--muted);
  line-height: 1.6;
}

.more {
  color: var(--accent);
  text-decoration: none;
  font-weight: 600;
  align-self: flex-start;
}

.more:hover {
  text-decoration: underline;
}

.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.project-card {
  background: var(--card-strong);
  border: 1px solid var(--border);
  border-radius: 18px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.project-card:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 255, 255, 0.14);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.card-top {
  background: linear-gradient(135deg, rgba(93, 228, 199, 0.05), rgba(124, 165, 255, 0.12));
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px;
}

.card-top img {
  max-width: 100%;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.02);
}

.card-body {
  padding: 16px 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.title-row h3 {
  margin: 4px 0;
  font-size: 20px;
}

.summary {
  margin: 0;
  color: var(--muted);
  line-height: 1.5;
}

.pill-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pill {
  padding: 6px 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid var(--border);
  font-size: 13px;
}

.pill-link {
  padding: 8px 12px;
  background: var(--card);
  color: var(--text);
  border-radius: 10px;
  border: 1px solid var(--border);
  text-decoration: none;
  font-weight: 600;
}

.pill-link:hover {
  color: var(--accent);
}

@media (min-width: 720px) {
  .header {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .header > div {
    max-width: 70%;
  }

  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
